import classnames from 'classnames';
import { mapValues } from 'lodash';
import { createUseStyles, useTheme } from 'react-jss';
import { Theme } from '@app/theme';
import { Colors } from '@app/theme';
import { GenericButton } from '@app/core';

const useStyles = createUseStyles<string, {}, Theme>((theme: Theme) => ({
  label: {
    ...theme.fonts.label,
  },
  buttonsContainer: {
    display: 'flex',
    flexDirection: 'row',
  },
  button: {
    padding: [[theme.marginBase, theme.marginBase * 2]],

    ...theme.fonts.caption,
    color: theme.colors.inkSecondary,

    border: {
      width: 1,
      style: 'solid',
      color: theme.colors.grayBorder,
    },

    borderRightWidth: 0,

    '&:first-child': {
      borderTopLeftRadius: theme.borderRadius.std,
      borderBottomLeftRadius: theme.borderRadius.std,
    },
    '&:last-child': {
      borderTopRightRadius: theme.borderRadius.std,
      borderBottomRightRadius: theme.borderRadius.std,
      borderRightWidth: 1,
    },
  },
}));

const useActiveStyles = createUseStyles((theme: Theme) => {
  return mapValues(theme.colorDefinitions, ({ muted, std }) => ({
    backgroundColor: muted,
    color: theme.colors.inkPrimary,
    borderColor: std,
    borderRightWidth: 1,
  }));
});

interface Props<T> {
  options: { value: T; label: string }[];
  selectedValue: T | undefined;
  onChange: (value: T) => void;
  color?: Colors;
  className?: string;
}

export const ToggleGroup = function <T extends string = string>({
  options,
  selectedValue,
  onChange,
  color = 'ink',
  className,
}: Props<T>) {
  const theme = useTheme() as Theme;
  const classes = useStyles({ theme });
  const activeColorsClasses: any = useActiveStyles({ theme });

  return (
    <div className={classes.buttonsContainer}>
      {options.map((option) => {
        const onClick = () => onChange(option.value);
        return (
          <GenericButton
            type="button"
            onClick={onClick}
            className={classnames(
              classes.button,
              {
                [activeColorsClasses[color]]: option.value === selectedValue,
              },
              className,
            )}
            key={option.value}
          >
            {option.label}
          </GenericButton>
        );
      })}
    </div>
  );
};
